export class Exercise {
  private _totalOccurrence = 0;

  constructor(
    public id: number,
    public exerciseName: string,
    public reference: string,
    public occurrence: number,
    public accent1: string,
    public accent1Color: string,
    public accent2: string,
    public accent2Color: string,
    public accent3: string,
    public accent3Color: string
  ){
  }

  set totalOccurrence(total: number) {
    this._totalOccurrence = total;
  }

  get totalOccurrence(): number {
    return this._totalOccurrence;
  }
}
